export default "__VITE_ASSET__DOkED1je__"